import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import setupAutoLogout from "./autoLogout"; // Import the autoLogout utility
import { setupAutoLogout } from "./autoLogout";
import { jwtDecode } from "jwt-decode";

// Function to check if token is expired (shared logic)
const isTokenExpired = (token) => {
    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000; // Current time in seconds
        return decoded.exp < currentTime;
    } catch (error) {
        console.error("Error decoding token:", error);
        return true; // Assume expired if decoding fails
    }
};

const useAutoLogout = ({ isAuthenticated }) => {
    const location = useLocation();
    const navigate = useNavigate();

    // Function to handle logout with URL preservation
    const handleLogout = () => {
        localStorage.removeItem("token");
        navigate("/login", {
            state: {
                returnTo: location.pathname + location.search,
            },
        });
    };

    // Check authentication and JWT expiration
    const checkAuth = () => {
        const token = localStorage.getItem("token");
        if (!isAuthenticated || (token && isTokenExpired(token))) {
            handleLogout();
        }
    };

    useEffect(() => {
        // Run the authentication check on mount and when location changes
        checkAuth();

        // Set up the auto-logout timer
        setupAutoLogout({
            logoutFn: handleLogout,
            onWarning: ({ logout, timeUntilExpiration }) => {
                const userResponse = window.confirm(
                    `Your session will expire in ${Math.floor(
                        timeUntilExpiration / 1000
                    )} seconds. Stay logged in?`
                );
                if (userResponse) {
                    // Add your refresh token logic here if applicable
                    // Example: refreshToken().then(newToken => localStorage.setItem('token', newToken));
                    // If refresh fails, call logout()
                } else {
                    logout();
                }
            },
        });
    }, [location, navigate, isAuthenticated]);
};

export default useAutoLogout;
